<template>
  <div class="punchtheclockcontent">
    <!-- <div class="punchtheclockHead">
        考勤打卡
    </div> -->
    <!-- <button  @click="shuxin" >刷新页面</button> -->
    <div class="flowChart">
        <!-- 签到 -->
        <div class="flowChartPer">
            <!-- 点 -->
            <div class="slideDown">
                <p class="spot"></p>
                <p class="line" v-if="dataContent.isPunch&&(dataContent.isSignIn||dataContent.activeEnd)"></p>
            </div>
            <div class="unchInformation">
                <p class="place">签到时间 {{dataContent.punchStartTime}}</p>
                <p v-if="!dataContent.isSignIn&&dataContent.activeEnd" class="signinTime checkInTimes" style="color:red;">缺卡</p>
                <p class="signinTime checkInTimes"  v-if="dataContent.isSignIn">打卡时间 {{dataContent.checkInTime}}</p>
                <p class="place" v-if="dataContent.isSignIn"><i class="iconfont icon-weizhi"></i> {{dataContent.place}}</p>
                <div class="photoBox" v-if="!dataContent.isSignIn&&!dataContent.activeEnd">
                    <p class="signinTime boildTitle">请先上传一张附近的照片</p>
                    <div class="photoBlock" v-if="imgUlr">
                        <i class="iconfont icon-guanbi1" @click.stop="guanImg"></i>
                        <img :src="imgUlr" alt="">
                    </div>
                    <!-- 拍照  -->
                    <div class="fileBox" v-if="!imgUlr">
                        <input type="file" accept="image/*" @change="fileChangeImg">
                    </div>
                </div>
                <p class="signinTime boildTitle" v-if="!dataContent.isSignIn&&!dataContent.activeEnd"><i class="iconfont icon-weizhi"></i> {{dataContent.place}}</p>
            </div>
            <!-- 打卡操作 -->
            <div class="punchCircle" v-if="!dataContent.isSignIn&&!dataContent.activeEnd">
                <div class="contentCircle" @click="signOpration(0)">签到打卡</div>
                <p class="place">
                    <span style="color:#2C9DFF">您的位置</span> 
                    <span>{{positionInfor.placeName}} </span>
                    <!-- <span  @click="refreshPosition" style="color:#2C9DFF;text-decoration: underline;">刷新</span> -->
                </p>
            </div>
        </div>
        <!-- 签退样式 -->
        <div class="flowChartPer" v-if="dataContent.isPunch&&(dataContent.isSignIn||dataContent.activeEnd)">
            <!-- 点 -->
            <div class="slideDown">
                <p class="spot"></p>
            </div>
            <div class="unchInformation">
                <p class="place">签退时间 {{dataContent.punchEndTime}}</p>
                <p class="signinTime checkInTimes" v-if="dataContent.isSignDown">打卡时间 {{dataContent.checkOutTime}}</p>
                <p class="place" v-if="dataContent.isSignDown"><i class="iconfont icon-weizhi"></i> {{dataContent.place}}</p>
                <div class="photoBox" v-if="!dataContent.isSignDown">
                    <p class="signinTime boildTitle">请先上传一张附近的照片</p>
                    <div class="photoBlock" v-if="imgUlr">
                        <i class="iconfont icon-guanbi1" @click.stop="guanImg"></i>
                        <img :src="imgUlr" alt="">
                    </div>
                    <!-- 拍照  -->
                    <div class="fileBox" v-if="!imgUlr">
                        <input type="file" accept="image/*" @change="fileChangeImg">
                    </div>
                </div>
                <p class="signinTime boildTitle" v-if="!dataContent.isSignDown"><i class="iconfont icon-weizhi"></i> {{dataContent.place}}</p>
            </div>
            <!-- 打卡操作 -->
            <div class="punchCircle" v-if="!dataContent.isSignDown">
                <div class="contentCircle" @click="signOpration(1)">签退打卡</div>
                <p class="place">
                    <span style="color:#2C9DFF">您的位置</span> 
                    <span>{{positionInfor.placeName}} </span>
                    <!-- <span  @click="refreshPosition" style="color:#2C9DFF;text-decoration: underline;">刷新</span> -->
                </p>
            </div>
        </div>
    </div>
    <!--  -->
    <van-dialog v-model="showCard" title="确定要补卡吗？" show-cancel-button @confirm="determineCard">
        <!-- <van-field
        v-model="explainCard"
        rows="2"
        autosize
        label=""
        type="textarea"
        maxlength="50"
        placeholder="请输入补卡说明"
        show-word-limit
        /> -->
        <div class="notesContent">注：{{notes?"不在活动地点内，只能进行补卡":"您已过了签到时间，只能进行补卡"}}</div>
        <!-- <img src="https://img.yzcdn.cn/vant/apple-3.jpg" /> -->
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);
export default {
    data(){
        return{
            dataContent:{
                punchStartTime:"", //签到时间
                punchEndTime:"",   //签退时间
                isPunch:0 ,//0只签到 1签到签退
                isSignIn:true, //签到是否打卡
                isSignDown:true,
                checkInTime: "",
                checkOutTime: "",
            }, //数据
            positionInfor:{ //位置信息
                longitude:"" , //经度
                latitude:""  , //纬度
                placeName:"定位中…",  //现场地址名称
            },
            imgUlr:"", //预览图片
            allFileimg:null ,//图片文件
            alltoast:null, //图片上传提示
            showCard:false, //补卡显示
            explainCard:"", //补卡说明
            notes:""  , //注释
        }
    },
    created(){
        this.indexListJavaPage(); //获取数据
        window['toH5LocationValue'] = (location) => { //安卓给数据
            this.positionInfor=location; //地理位置
        };

        // ios登入 地理位置
        var that=this;
        this.setupWebViewJavascriptBridge(function(bridge){
            bridge.registerHandler("toH5LocationValue", function(location,responseCallback){
                that.positionInfor=location; //地理位置
                var responseData = {"Javascript Says": "Right back atcha!"};
                responseCallback(responseData);
            });
        });

    },
    methods:{
        shuxin(){
            this.currency('toRefreshPunch','');
        },
        // 接口数据 java
		indexListJavaPage(){
            this.$http.get(this.javalinkTwo+"activity/query/info/"+this.$route.query.id,{
                params:{
                    memberId:window.localStorage.civilizationId
                }
            })
            .then(resp=>{
                if(resp.data.success){
                    this.dataContent = resp.data.data;
                    var myDate= Date.parse(new Date());//当前时间搓
                    var date = this.dataContent.punchEndTime.replace(/-/g,'/');
                    var timestamp = new Date(date).getTime();
                    if(myDate>timestamp){ //可以签退
                        this.dataContent.activeEnd = true;
                    }else{ //不可以签退
                        this.dataContent.activeEnd = false;
                    }
                }
                // console.log(resp);
            }).catch((err)=>{
                console.log(err);
            })
        },
        // 图片改变
		fileChangeImg(e){
			var files = e.target.files[0];
			if(files.type.search(/image/g)==-1){
				Toast('只能上传jpg、jpeg、png格式');
				return;
			}
			if(files.type.search(/jpg/g)==-1&&files.type.search(/jpeg/g)==-1&&files.type.search(/png/g)==-1){
				Toast('只能上传jpg、jpeg、png格式');
				return;
			}
			var that=this;
			if (e.target.files&&files) { //图片预览
				var reader = new FileReader();
				reader.onload = function(evt) {
                    that.imgUlr=evt.target.result;
                    that.allFileimg=files; //图片文件
				}
				reader.readAsDataURL(files);
			} 
        },
        // 刷新定位
        refreshPosition(){},
        // 重新上传图片
        guanImg(){
            this.imgUlr=""; //预览图片
            this.allFileimg=null; //图片文件
        },
        // 签到签退打卡
        signOpration(identification){
            //判断距离
            var myDate,date,timestamp;//当前时间搓 字符串日期 字符串转时间搓
            var instance=this.getFlatternDistance(this.positionInfor.latitude,this.positionInfor.longitude,this.dataContent.latitude,this.dataContent.longitude);
            if(instance>this.dataContent.signInRange){
                if(identification==0){ //签到 必须在考勤范围内
                    Toast('不在打卡范围内！');
                }else{
                    if(this.dataContent.replacementCardCount>0){ //判断有没有补卡次数 大于零有补卡次数
                        // 判断有没有到签退时间
                        myDate= Date.parse(new Date());//当前时间搓
                        date = this.dataContent.punchEndTime.replace(/-/g,'/');
                        timestamp = new Date(date).getTime();
                        if(myDate>=timestamp){   //到了签退时间 
                            this.showCard=true;  //
                            this.notes =1; //补签退
                            // Toast('提示补卡！');
                        }else{ //没有到签到时间不给打签退卡
                            Toast('当前活动尚未结束,签退打卡通道尚未开启,请等待活动结束后签退');
                        }
                    }else{ //没有补卡次数
                        Toast('不在打卡范围内！');
                    } 
                }
                return false;
            }else{  //在考勤范围内
                if(identification==0){ //签到
                     // 判断有没有到签退时间
                    if(this.dataContent.punchStartTime){
                        myDate= Date.parse(new Date());//当前时间搓
                        date = this.dataContent.punchStartTime.replace(/-/g,'/');
                        timestamp = new Date(date).getTime();
                        if(myDate>timestamp){   //过了签到时间 
                            // 判断有没有补卡机会 有补卡机会
                            if(this.dataContent.replacementCardCount>0){ //有补卡机会
                                this.showCard=true;  //
                                this.notes =0; //补签到
                            }else{  //没有补卡机会 提示内容
                                Toast('当前活动已开始,签到打卡通道已关闭');
                            }
                            return false;
                        }
                    }
                }else{ //签退
                    // 判断有没有到签退时间
                    myDate= Date.parse(new Date());//当前时间搓
                    date = this.dataContent.punchEndTime.replace(/-/g,'/');
                    // alert(date);
                    timestamp = new Date(date).getTime();
                    if(myDate<timestamp){   //没到签退时间 
                        Toast('当前活动尚未结束,签退打卡通道尚未开启,请等待活动结束后签退');
                        return false;
                    }
                }
            }
            // 判断有没有上传照片
            if(!this.allFileimg){
                Toast('请先上传一张附近的照片！');
                return false;
            }
            this.alltoast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '图片上传中...'
            });
            // 上传图片
            this.uploadFile(identification);
        },
        // 签到签退接口
        signOprationLink(identification,url){
            this.$http.post(this.javalinkTwo+"usercenter/member/app/add/sign",{
                memberId:window.localStorage.civilizationId,
                longitude:this.positionInfor.longitude, //经度
                latitude:this.positionInfor.latitude, //纬度
                livePic:url,   //现场照片
                placeName:this.positionInfor.placeName,  //现场地址名称
                activityId:this.$route.query.id, //活动id
                status:identification, //0签到 1签退
                punchFlag:1  //0补卡 1不补卡
            })
            .then(resp=>{
                // console.log(resp);
                Toast.clear();
                this.alltoast=null;//去掉背景
                if(resp.data.code=="10000"){
                    this.indexListJavaPage(); //刷接口
                    this.imgUlr="";//预览图片
                    this.allFileimg=null ;//图片文件
                    // 刷新前两个页面
                    this.currency("toRefreshPunch",""); 
                }else{
                    Toast.fail(resp.data.message);
                }
                
                // else{
                //     Toast.fail(resp.data.message);
                // }
            }).catch((err)=>{
                console.log(err);
                Toast.clear();
				this.alltoast=null;//去掉背景
            })
        },
        // 图片视频上传接口
		uploadFile(identification){
			var formData = new FormData();
			formData.append('file',this.allFileimg);
			var myExt = this.allFileimg.name.split(".");
			this.$http.post(this.javalinkTwo+"media/upload/picupload",
			formData,{
				headers: {"Content-Type": "multipart/form-data"},
				params: {
					ext: myExt[myExt.length-1],
					num: 3
				}
			}).then(resp => {
				if(resp.data.success){
                    // resp.data.data //图片url
					this.signOprationLink(identification,resp.data.data); //打卡接口
				}else{
					Toast.clear();
					this.alltoast=null;//去掉背景
					Toast.fail('上传失败，请稍后再试！');
				}
			}).catch(()=>{
				Toast.clear();
				this.alltoast=null;//去掉背景
				Toast.fail('上传失败，请稍后再试！');
			})
        },
         // 确定补卡
        determineCard(){
            this.$http.post(this.javalinkTwo+"usercenter/member/app/add/punch",{
                memberId:window.localStorage.civilizationId,
                // longitude:this.positionInfor.longitude, //经度
                // latitude:this.positionInfor.latitude, //纬度
                // livePic:url,   //现场照片
                // placeName:this.positionInfor.placeName,  //现场地址名称
                activityId:this.$route.query.id, //活动id
                status:this.notes, //0签到 1签退
                punchFlag:0  //0补卡 1不补卡
            })
            .then(resp=>{
                console.log(resp);
                if(resp.data.code=="10000"){
                    this.indexListJavaPage(); //刷接口
                     // 刷新前两个页面
                    this.currency("toRefreshPunch",""); 
                }else{
                    Toast.fail(resp.data.message);
                }
            }).catch((err)=>{
                console.log(err);
                Toast.clear();
				this.alltoast=null;//去掉背景
            })
        },
        // 经纬度距离计算
        getFlatternDistance(lat1,lng1,lat2,lng2){
            var EARTH_RADIUS = 6378137.0; //单位M
            var radLat1 = this.getRad(lat1);
            var radLat2 = this.getRad(lat2);
            var a = radLat1 - radLat2;
            var b = this.getRad(lng1) - this.getRad(lng2);
            var s = 2*Math.asin(Math.sqrt(Math.pow(Math.sin(a/2),2) + Math.cos(radLat1)*Math.cos(radLat2)*Math.pow(Math.sin(b/2),2)));
            s = s*EARTH_RADIUS;
            s = Math.round(s*10000)/10000.0;
            return s;
        },
        getRad(d){
            var PI = Math.PI;
            return d*PI/180.0;
        }
    }
}
</script>

<style lang="less">
    .notesContent{
        width: 100%;
        padding: 10px 16px;
        box-sizing: border-box;
    }
    .punchtheclockcontent{
        .punchtheclockHead{
            height: 64px;
            width: 100%;
            box-sizing: border-box;
            padding-top: 24px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            background: #DD2828;
            font-size: 16px;
        }
        .flowChart{
            width: 100%;
            margin-top: 20px;
            .flowChartPer{
                width: 100%;
                height: auto;
                padding: 10px 38px;
                box-sizing: border-box;
                position: relative;
                padding-bottom: 35px;
                .slideDown{
                    position: absolute;
                    top: 10px;
                    left: 18px;
                    height: 100%;
                    .spot{
                        position:absolute;
                        top: 7px;
                        width: 10px;
                        height: 10px;
                        background: #6294F8;
                        border-radius: 100%; 
                        z-index: 99;
                        // #B2B2B2
                    }
                    .line{
                        width: 1px;
                        height: 100%;
                        position: absolute;
                        top: 7px;
                        left: 4.5px;
                        background: #B2B2B2;
                    }
                }
                .unchInformation{
                    width: 100%;
                    .signinTime{
                        color: #666;
                        font-size: 16px;
                        width: 100%;
                    }
                    .checkInTimes{
                        margin: 10px 0px;
                    }
                    .boildTitle{
                        font-weight: bold;
                        margin-top: 10px;
                    }
                    .place{
                        height: 24px;
                        line-height: 24px;
                        color: #999;
                        width: 100%;
                    }
                    .photoBox{
                        width: 100%;
                        height: 161px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-wrap: wrap;
                        .photoBlock{
                            width: 120px;
                            height: 120px;
                            margin-top: 10px;
                            position: relative;
                            img{
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                            .icon-guanbi1{
                                position: absolute;
                                right: -8px;
                                top: -8px;
                                z-index: 99;
                            }
                        }
                        .fileBox {
                            width: 120px;
                            height: 120px;
                            margin-top: 10px;
                            // margin-left: 4%;
                            // height: 28%;
                            border: 1px solid #ebedf0;
                            background: url("../../../assets/images/jiahao.png") no-repeat;
                            background-size: 50% 50%;
                            background-position: center;
                            background-repeat: no-repeat;
                            // margin-bottom: 10px;
                            position: relative;
                            input {
                                position: absolute;
                                z-index: 1;
                                top: 0px;
                                left: 0px;
                                display: block;
                                width: 100%;
                                height: 100%;
                                overflow: hidden;
                                opacity: 0;
                            }
                        }
                    }
                }
                .punchCircle{
                    width: 100%;
                    // height: 160px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-wrap: wrap;
                    .contentCircle{
                        // margin-left: 30px;
                        margin-top: 10px;
                        width: 120px;
                        height: 120px;
                        background: linear-gradient( rgb(98, 189, 253), #22A3FF,#2F98FD);
                        border-radius: 100%;
                        color: #fff;
                        box-shadow: 0 2px 12px 0 rgba(98, 189, 253, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 16px;
                    }
                    .place{
                        width: 100%;
                        color: #999;
                        margin-top: 10px;
                        width: 100%;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>